import { DataSyncReconnectButton } from './DataSyncReconnectButton';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { DataSyncServiceComponent } from './DataSyncServiceComponent';
export const DataSyncReconnectionConfig = {
  reconnectButton: DataSyncReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED],
  serviceComponent: DataSyncServiceComponent
};